function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

export { expandToHashMap as default };
//# sourceMappingURL=expandToHashMap.js.map
